import React, { Component } from "react";
class HomePage extends Component {
  componentWillMount = () => {
    this.props.setAppDefault();
  };
  componentDidMount = () => {
    window.scrollTo(-100, -100)
  };

  render() {

    return (
      <div
        className="flex-container"
        style={{
          display:
            this.props.appState.currentPage === "home" ? "block" : "none",
        }}
      >
        <div className="flex-container">
          <p>
            This is an{" "}
				<a
              href="https://spire.ee.iisc.ac.in/spire/non_nativeSS.php"
              target="_blank"
              rel="noopener noreferrer"
				>
              Accent Conversion{" "}
				  </a>
            project from SPIRE lab. Please contribute your voice to support this project.
          </p>
        </div>
        <div className="row">

          <div className="text-center col-md-7">
            {/* <h1>Welcome</h1> */}

            <div className="">

              <div
                className="flex-container mt-4 mb-4"
                style={{
                  maxHeight: "20rem",
                  maxWidth: "35rem",
                  overflow: "auto",
                  margin: "auto",
                  borderStyle: "groove",
                }}
              >
                <h2>Consent to Audio Recording</h2>

                <div>
                  <b>Principle Investigator</b>: Dr. Prasanta Kumar Ghosh
                    <br></br>
                  <p style={{ textAlign: "right" }}>
                    Department of Electrical Engineering
                    <br></br>
                    Indian Institute of Science, Bangalore
                    <br></br>
                  </p>
                </div>

                <div>
                  <b>Confidentiality of records</b>: The records of this study will be
                    kept confidential. Only the researchers associated with this study
                    will be given access to these records.
                </div>

                <div>
                  <b>Taking part is voluntary</b>: Taking part in this study is
                    completely voluntary. Participants can pause whenever they are tired
                    in the long recordings and they are free to leave recording at any
                    time for any reason. Even after signing the informed consent form, a
                    participant may choose to withdraw from recording.
                </div>

                <div>
                  <b>Statement of Consent</b>: I have read the above information. I
                    consent to take part in the study
                </div>
              </div>


            </div>



            {/* <button
              className="btn btn-dark"
              onClick={() => this.props.setCurrentPage("terms")}
            >
              Start recording
            </button> */}

          </div>



          <div
            className="flex-container"
            style={{ maxWidth: "30rem", margin: "auto" }}
          >
            <small className="mb-2">
              By clicking proceed, you are agreeing to the adjacent terms and
              conditions
          </small>

            <button
              className="btn btn-dark flex-container" style={{ backgroundColor: "#800000" }}
              onClick={this.props.appState.isLoggedIn?() => this.props.setCurrentPage("meta"):this.props.login}              
            >
              Click to Login and Proceed
          </button>
          </div>

        </div>

        <div className="flex-container">
          <div className="text-left ml-5">
            <b>Instructions:</b>
            <ul>
              <li>
                If you have a social account (facebook or google), please login
                for our ease of data maintenance.
                </li>
              <li>
                In case you don't have a social account, please ask another
                person close to you, a family member or a friend with a social
                account to login to our website. This will help us map you to
                the previous recordings you have generously provided.
                </li>
              <li>
                In case you can't at all abide by the above two options, don't
                worry, we have you covered. We respect your privacy, stay
                anonymous and contribute your voice.
                </li>
              <li>
                If you face <i>network error</i> message while trying to login, please reload
                  the page again and ensure that you have a good internet connection.
                </li>
              <li style={{ color: "red" }}>
                Please use either Google Chrome or Mozilla Firefox (non iOS device) for contributing your speech using this web application.
                </li>
            </ul>
          </div>
		  {/*
            <h4>Demo of the website</h4>
            <div className="mb-4">

              <iframe title='instructions' frameBorder="0" height="200" src=
                "https://www.youtube.com/embed/vWYI7pMXxv4" width=
                "350" style={{ maxWidth: "100%" }} allowFullScreen></iframe>
            </div>
          </div>
          
		  <button
            className="btn btn-dark"
            onClick={() => this.props.setCurrentPage("terms")}
          >
            Start recording
          </button>
		  */}

        </div>

      </div>
    );
  }
}

export default HomePage;
